<!-- 系统管理-角色管理 -->
<template>
  <div class="md-layout">
    <!-- 卡片 -->
    <div class="md-layout-item md-size-100">
      <md-card style="margin-bottom: 0;">
        <!-- 卡片-主体 -->
        <md-card-content>
          <!-- 卡片-查询表单 -->
          <div class="md-layout card-form" style="max-width: 800px;">
            <div class="md-layout-item md-size-20 left-layout-item md-xsmall-size-50">
              <md-field>
                <label>{{$I18n("alarm_event")}}</label>
                <md-input v-model="searchForm.type"/>
              </md-field>
            </div>
            <div class="md-layout-item md-size-20">
              <md-button class= "left-icon md-info" @click="form_changeSearchData">
                <md-icon>search</md-icon>
                {{$I18n("search")}}
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
    <!-- 卡片 -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <add-button @click="cfg_addItem">{{$I18n("add_event_type")}}</add-button>
          <!-- 表格 { 点击后可展示对应的子菜单 }
            角色 ID
            角色名称
            角色状态 {1: 打开, 2:禁止}
            创建时间
            操作 [修改角色, 删除角色]
           -->
          <md-table v-model="table_Data_cfg">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell :md-label="'ID'" class="numbers">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('alarm_event')">{{ item.type }}</md-table-cell>
              <md-table-cell :md-label="$I18n('event_name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('lang_flag')">{{ item.lang }}</md-table-cell>
              <md-table-cell :md-label="$I18n('lang_name')">{{ item.lang_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('update_date')">{{ item.update_date }}</md-table-cell>
              <md-table-cell :md-label="$I18n('create_time')">{{ item.create_date }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="cfg_editItem(item)" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click="cfg_delItem(item)" class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 卡片-表格-翻页 -->
        <table-page :total="cfg_Total" :pageSize="pageSize" v-model="cfg_Page"/>
      </md-card>
    </div>
    <div class="md-layout-item md-size-100">
      <md-card>
        <!-- 卡片-主体 -->
        <md-card-content>
          <add-button @click="tem_addItem">{{$I18n("add_msg_tem")}}</add-button>
          <!-- 表格 { 点击后可展示对应的子菜单 }
            角色 ID
            角色名称
            角色状态 {1: 打开, 2:禁止}
            创建时间
            操作 [修改角色, 删除角色]
           -->
          <md-table v-model="table_Data_tem">
            <md-table-row slot="md-table-row" slot-scope="{ item }" >
              <md-table-cell :md-label="$I18n('id')">{{ item.id }}</md-table-cell>
              <md-table-cell :md-label="$I18n('name')">{{ item.name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('title')">{{ item.title }}</md-table-cell>
              <md-table-cell :md-label="$I18n('category')">{{ item.mode_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('type')">{{ item.type_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('language')">{{ item.lang_name }}</md-table-cell>
              <md-table-cell :md-label="$I18n('operate')"  class="button-box">
                <md-button @click="tem_editItem(item)" class="md-just-icon md-round md-info left-icon">
                  <md-icon>edit</md-icon>
                </md-button>
                <md-button @click="tem_delItem(item)" class="md-just-icon md-round md-danger md-info">
                  <md-icon>close</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>

            <md-table-empty-state slot="md-table-empty-state"> {{$I18n("none_data")}} </md-table-empty-state>
          </md-table>
        </md-card-content>
        <!-- 卡片-表格-翻页 -->
        <table-page :total="tem_Total" :pageSize="pageSize" v-model="tem_Page"/>
      </md-card>
    </div>
    <!-- 弹窗 -->
    <!-- cfg_tem_ -->
    <simple-modal 
      ref    = "cfg_modal"
      :title = "modal_title"
      :right = "modal_type!=='delete'"
      @submit= "cfg_modal_form_submit"
      @close = "closeModal"
    >
      <!-- 弹窗-主题 -->
      <template slot="body">
        <!-- 弹窗-删除弹窗 -->
        <div v-if="modal_type==='delete'">{{
          $I18n("check_delete", cfg_modalData.Form.name)
        }}</div>
        <!-- 弹窗-修改/添加弹窗表单 -->
        <div v-else>
          <common-form-item
            v-for="item in cfg_form_modalData" 
            v-model="cfg_modalData.Form[item.keys]" 
            :error="cfg_modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal >
    <simple-modal 
      ref    = "tem_modal"
      :title = "modal_title"
      :right = "modal_type!=='delete'"
      @submit= "tem_modal_form_submit"
      @close = "closeModal"
    >
      <!-- 弹窗-主题 -->
      <template slot="body">
        <!-- 弹窗-删除弹窗 -->
        <div v-if="modal_type==='delete'">{{
          $I18n("check_delete", tem_modalData.Form.lang_name)
        }}</div>
        <!-- 弹窗-修改/添加弹窗表单 -->
        <div v-else>
          <common-form-item
            v-for="item in tem_form_modalData" 
            v-model="tem_modalData.Form[item.keys]" 
            :error="tem_modalData.Error[item.keys]" 
            :key="item.keys" v-bind="item"
          />
        </div>
      </template>
    </simple-modal >
  </div>
</template>
<script>
import { /*timestampToString1000,*/ timestampToString, FormClass } from "@/common/tools.js";
import {languageInfo} from "@/common/languageInfo.js";
export default {
  data() {
    let languageList = [{
      short_name  : "ALL",
      ch_name: "全部",
    }];
    for(var key in languageInfo){
      languageList.push(languageInfo[key]);
    }
    return {
      companys:[],
      languageList,
      icon : "person",                   // 主体-卡片-ICON
      title : this.$I18n("role_manage"), // 主体-卡片-标题
      table_rowData_cfg : [],            // 主体-表格-原始数据
      table_rowData_tem : [],            // 主体-表格-原始数据
      cfg_Page : 1,                   // 主体-表格-所处页面
      tem_Page : 1,
      cfg_Total : 0,                         // 主体-表格-数据总数
      tem_Total : 0,                         // 主体-表格-数据总数
      pageSize : 10,                     // 通用-表格每页数据数量

      modal_type : "add",                // 弹窗-打开类型 ["add", "edit", "delete"]
      modal_title : "",                  // 弹窗-弹窗标题

      formData : {
        type:"",
      },
      searchForm : {
        type:"",
      },

      // 弹窗表单相关
      cfg_modalData : new FormClass({
        name : {
          init: "",
          check: "required",
        },
        lang : {
          init: languageList[0].short_name,
          check: "required",
        },
        type: {
          init : "",
          check: "int",
        },
        // SP 偷懒
        sp : "",
      }),
      tem_modalData : new FormClass({
        name: {
          init : "",
          check: "required",
        },
        title: {
          init : "",
          check: "required",
        },
        lang: {
          init : "en",
          check: "required",
        },
        body: {
          init : "",
          check: "required",
        },
        mode       : 1,
        param      : '',
        notify_type: 1,
        type       : 2,
        comp_path  : "",
      }),
    };
  },
  mounted : function() {
    this.$api.getCompanyList({})
      .then(this.$Then(res => {
        this.companys = res.data.map(item => ({
          ...item,
          comp_path: item.path,
        }));
        var initCompPath = ""
        const initComp = this.companys.filter(i => {i.comp_id == this.UserInfo.comp_id})[0];
        if(initComp){
          initCompPath = initComp.path;
        } else {
          initCompPath = this.companys[0]?.path;
        }
        this.tem_modalData.SetInit(initCompPath, 'comp_path')
      }))
      .catch(this.$Catch());

    this.api_getCfgData();
    this.api_getTemData();
  },
  watch:{
    cfg_Page(){
      this.api_getCfgData();
    },
    tem_Page(){
      this.api_getTemData();
    },
    'tem_modalData.Form.lang_flag'(val){
      this.tem_modalData.Form.lang_name = this.languageList.filter(i => i.en_name === val)[0].ch_name;
    },
  },
  methods: {
    form_changeSearchData(){
      this.formData = {...this.searchForm}
      this.cfg_Page = 1;
      this.api_getCfgData();
    },
    closeModal(){
      this.cfg_modalData.Reset();
      this.tem_modalData.Reset();
    },
    api_getCfgData(){
      this.$api.getMsgCfg({
        ...this.formData,
        page_size: this.pageSize,
        page_no  : this.cfg_Page,
      })
        .then(this.$Then(res => {
          this.table_rowData_cfg = res.data.map(item => {
            return {
              ...item,
              state: item.state ?item.state :0,
            };
          })
          this.cfg_Total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.table_rowData_cfg = [];
          this.cfg_Total = 0;
        }))
    },
    api_getTemData(){
      this.$api.getVoiceTemplate({
        type: 1,
        page_size: this.pageSize,
        page_no  : this.tem_Page,
      })
        .then(this.$Then(res => {
          // res.data.forEach(i => console.log(i.notify_type))
          this.table_rowData_tem = res.data.map(item => {
            return {
              ...item,
              state: item.state ?item.state :0,
            };
          })
          this.tem_Total = res.count;
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.table_rowData_tem = [];
          this.tem_Total = 0;
        }))
    },

    modal_closeModal () {               // 弹窗-关闭弹窗
      this.$refs.cfg_modal.close()
      this.$refs.tem_modal.close()
    },
    cfg_addItem(){
      this.modal_title = this.$I18n("add_msg");
      this.modal_type  = "add";
      this.$refs.cfg_modal.open();
      this.cfg_modalData.Reset();
    },
    cfg_editItem(item){
      this.modal_title = this.$I18n("edit_msg");
      this.modal_type  = "edit";
      this.$refs.cfg_modal.open();
      this.cfg_modalData.Update(item);
    },
    cfg_delItem(item){
      this.modal_title = this.$I18n("del_msg");
      this.modal_type  = "delete";
      this.$refs.cfg_modal.open();
      this.cfg_modalData.Update(item);
    },
    tem_addItem(){
      this.modal_title = this.$I18n("add_msg_temp");
      this.modal_type  = "add";
      this.$refs.tem_modal.open();
      this.tem_modalData.Reset();
    },
    tem_editItem(item){
      this.modal_title = this.$I18n("edit_msg_temp");
      this.modal_type  = "edit";
      this.$refs.tem_modal.open();
      this.tem_modalData.Update(item);
    },
    tem_delItem(item){
      this.modal_title = this.$I18n("del_template");
      this.modal_type  = "delete";
      this.$refs.tem_modal.open();
      this.tem_modalData.Update(item);
    },

    add_list(itemList){
      var item = itemList.pop();
      return this.$api.addMsgCfg({
        name: item[0],
        lang: item[1],
        type: item[2],
      })
        .then(this.$Then(() => {
          if(itemList.length>0){
            this.add_list(itemList);
          } else{
            this.$successMsg("结束");
          }
        }))
        .catch(this.$Catch(this.$I18n("add_fail")))
    },

    cfg_modal_form_submit () {              // 弹窗-表单-提交表单
      if(this.$router.history.current.query.sp == 1 && this.cfg_modalData.Form.sp){
        var formList = this.cfg_modalData.Form.sp.split("\n").map(i => {
          return i.split(",")
        })
        this.add_list(formList)
        return 
      }
      if(this.modal_type === "delete"){
        this.$api.delMsgCfg(this.cfg_modalData.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("delete_success"));
            this.modal_closeModal();
            this.api_getCfgData();
          }))
          .catch(this.$Catch(this.$I18n("delete_fail")))
        return 
      }
      if(this.cfg_modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return
      }
      
      if (this.modal_type === "add") {
        this.$api.addMsgCfg(this.cfg_modalData.Form)
          .then(this.$Then(() => {
              this.$successMsg(this.$I18n("add_success"));
              this.modal_closeModal();
              this.api_getCfgData();
          }))
          .catch(this.$Catch(this.$I18n("add_fail")))
      } else if (this.modal_type === "edit"){
        this.$api.editMsgCfg(this.cfg_modalData.Form)
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("edit_success"));
            this.modal_closeModal();
            this.api_getCfgData();
          }))
          .catch(this.$Catch(this.$I18n("edit_fail")))
      }
    },
    tem_modal_form_submit () {              // 弹窗-表单-提交表单
      if(this.modal_type === "delete"){
        this.$api.delVoiceTemplate({
          ...this.tem_modalData.Form,
          type: 1,
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("delete_success"));
            this.modal_closeModal();
            this.api_getTemData();
          }))
          .catch(this.$Catch(this.$I18n("delete_fail")))
        return 
      }
      if(this.tem_modalData.Check()){
        this.$errorMsg(this.$I18n("pls_check_verify"));
        return
      }
      
      if (this.modal_type === "add") {
        this.$api.addVoiceTemplate({
          ...this.tem_modalData.Form,
          type : 1,
          body : this.tem_modalData.Form.body?this.tem_modalData.Form.body.replace(/'/g,"\\'") :"",
        })
          .then(this.$Then(() => {
              this.$successMsg(this.$I18n("add_success"));
              this.modal_closeModal();
              this.api_getTemData();
          }))
          .catch(this.$Catch(this.$I18n("add_fail")))
      } else if (this.modal_type === "edit"){
        this.$api.editVoiceTemplate({
          ...this.tem_modalData.Form,
          type : 1,
          body : this.tem_modalData.Form.body?this.tem_modalData.Form.body.replace(/'/g,"\\'") :"",
        })
          .then(this.$Then(() => {
            this.$successMsg(this.$I18n("edit_success"));
            this.modal_closeModal();
            this.api_getTemData();
          }))
          .catch(this.$Catch(this.$I18n("edit_fail")))
      }
    },
  },
  computed: {
    table_Data_cfg(){     // 表格数据
      if (!this.table_rowData_cfg || this.table_rowData_cfg.length === 0){
        return [];
      } else {
        return [...this.table_rowData_cfg]
          .map(i => {
            const lang_item = this.languageList.filter(item => item.short_name === i.lang)[0]
            return {
              ...i,
              lang_name  : lang_item ?lang_item.ch_name :"",
              create_date: timestampToString(new Date (i.created_at) .getTime()),
              update_date: timestampToString(new Date (i.updated_at) .getTime()),
            }
          })
      }
    },
    table_Data_tem(){     // 表格数据
      if (!this.table_rowData_tem || this.table_rowData_tem.length === 0){
        return [];
      } else {
        return [...this.table_rowData_tem]
          .map(item => {

            let notify_type_options = [];
            if(item.mode == 1){
              notify_type_options = this.$Param.notifyTypeFull
            } else if(item.mode == 2){
              notify_type_options = this.$Param.noticeTempType
            } else if(item.mode == 3){
              notify_type_options = this.$Param.alarmType
            }
            let type_name = this.$I18n(notify_type_options.getName(item.notify_type, "all"));
            let lang_name = "";
            switch (item.lang) {
              case "en":
                lang_name = "en(" + this.$I18n("en") + ")";
                break;
              case "zh-TW" :
                lang_name = "zh-TW(" + this.$I18n("zh-TW") + ")";
                break;
              case "zh-CN":
                lang_name = "zh-CN(" + this.$I18n("zh-CN") + ")";
                break;
              default :
                var langNameObj = this.languageList.filter(i => i.short_name == item.lang)[0];
                if(langNameObj){
                  lang_name = langNameObj.ch_name
                } else {
                  lang_name = item.lang;
                }
                break;
            }
            let mode_name = "";
            switch(item.mode){
              case 1:
                mode_name = this.$I18n("system")
                break
              case 2:
                mode_name = this.$I18n("the_pay")
                break
              case 3:
                mode_name = this.$I18n("alarm")
                break
            }
            return {
              ...item,
              type_name,
              lang_name,
              mode_name,
              notify_type: item.notify_type ?item.notify_type : 0,
            }
            // return {
            //   ...i,
            //   mode_name  : this.$I18n(this.$Param.tempParamsList.getName(i.mode, "unknow")),
            //   create_date: timestampToString1000(i.gmt_create),
            //   update_date: timestampToString1000(i.gmt_update),
            // }
          })
      }
    },
    cfg_form_modalData(){
      return [
        {
          label   : this.$I18n("event_name"),
          keys    : "name",
          type    : "input",
          check   : true,
          required: true
        },{
          label   : this.$I18n("lang_flag"),
          keys    : "lang",
          type    : "select",
          options : this.languageList.map(i => {
            return {
              id  : i.short_name,
              name: i.ch_name,
            }
          }),
          check   : true,
          required: true,
        },{
          label   : this.$I18n("alarm_event"),
          keys    : "type",
          type    : "input",
          check   : true,
          required: true,
        },{
          label   : "SP",
          keys    : "sp",
          type    : "textarea",
          hide    : this.$router.history.current.query.sp != 1,
          placeholder: "名称,标识[SimpChinese / English / TradChinese],类型\n名称,标识[SimpChinese / English / TradChinese],类型"
        }
      ]
    },
    tem_form_modalData(){
      let notify_type_options = [];
      if(this.tem_modalData.Form.mode == 1){
        notify_type_options = this.$Param.notifyTypeFull
      } else if(this.tem_modalData.Form.mode == 2){
        notify_type_options = this.$Param.noticeTempType
      } else if(this.tem_modalData.Form.mode == 3){
        notify_type_options = [{id:0, name: 'all'} ,...this.$Param.alarmType]
      }
      notify_type_options = notify_type_options.map(i => {
        return {
          id  : i.id,
          name: this.$I18n(i.name),
        }
      })
      return [
        {
          label   : this.$I18n("name"),
          keys    : "name",
          type    : "input",
          check   : true,
          required: true,
        },{
          label   : this.$I18n("company"),
          keys    : "comp_path",
          type    : "select",
          options : this.companys.map(i => {
            return {
              id  : i.comp_path,
              name: i.comp_short_name ?i.comp_short_name :i.comp_name,
            }
          }),
          required: true
        },{
          label   : this.$I18n("title"),
          keys    : "title",
          type    : "input",
          check   : true,
          required: true,
        },{
          label   : this.$I18n("category"),
          keys    : "mode",
          type    : "select",
          options : [
            {id: 1, name: this.$I18n("system")},
            {id: 2, name: this.$I18n("the_pay")},
            {id: 3, name: this.$I18n("alarm")},
          ],
        },{
          label   : this.$I18n("type"),
          keys    : "notify_type",
          type    : "select",
          options : notify_type_options,
        },{
          label   : this.$I18n("lang"),
          keys    : "lang",
          type    : "select",
          options : this.languageList.map(i => {
            return {
              id  : i.short_name,
              name: i.ch_name,
            }
          }),
          check   : true,
          required: true
        },{
          label   : this.$I18n("body"),
          keys    : "body",
          type    : "textarea",
          check   : true,
          required: true
        },
      ]
    },
  },
}
</script>
<style lang="scss" scoped>
  .hidden-span{
    max-width: 30vw;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  @media screen and (max-width: 1400px){
    .hidden-span{
      max-width: 20vw;
    }
  }
  // 弹窗
  .lg-modal .modal-container{
    width : 80%;
    max-width: unset;
  }
  // 表格的ID列
  .numbers {
    width: 160px;
  }
  // 表格的按钮列
  .button-box {
    width: 120px;
  }
  .md-table .md-table-head:last-child {
    text-align: right;
  }
</style>